import { Component, ViewChild, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'termsandconditions',
    templateUrl: './termsandconditions.component.html',
    styleUrls: ['../pre-login.component.scss']
})
export class TermsAndConditionsComponent implements OnInit {
    
    ngOnInit() {
        window.scrollTo(0, 0);
    }
    constructor() { }
}


// WEBPACK FOOTER //
// ./src/app/components/customer-pre-login/termsandconditions/termsandconditions.component.ts